import { FC, useEffect } from 'react';
import { BasicAlert, CollapsiblePanel, ICollapsiblePanelComponentProps, Markdown } from '@ngt/forms';
import { Box, Button, Chip, Divider, styled, Typography, lighten, darken, Paper } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faObjectGroup } from '@fortawesome/pro-duotone-svg-icons';
import { ISourceDataFormGroupComponentProps } from '@/utilities/forms/SourceDataFormProcessor';
import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faInfoCircle } from '@fortawesome/pro-light-svg-icons';

const Title = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(2),
    margin: theme.spacing(0)
}));

const IconContainer = styled(Box)(({ theme }) => ({
    marginRight: theme.spacing(2)
}));

const TitleChip = styled(Chip)(({ theme }) => ({
    marginLeft: 'auto'
}));

const RepeatChip = styled(Chip)(({ auto, theme }: any) => ({
    marginLeft: auto ? 'auto' : theme.spacing(1)
}));

const Content = styled(Box)(({ theme }) => ({
    margin: theme.spacing(0, 0, 0, 0),
    background: theme.palette.mode === 'dark' ? 
        lighten(theme.palette.common.black, 0.18) :
        darken(theme.palette.common.white, 0.03)
}));

const SourceDataFormGroupTitled: FC<ISourceDataFormGroupComponentProps> = ({
    formSectionLabel,
    formSectionConfiguration,
    children
 }) => {
    return (
        <Paper square>
            <Title variant="h4">
                <IconContainer>
                    <FontAwesomeIcon icon={faObjectGroup} />
                </IconContainer>
                {formSectionLabel}
            </Title>
            <Content>
                { 
                    !!formSectionConfiguration?.alertInformation && (
                        <BasicAlert
                            description={<Markdown.Preview>{formSectionConfiguration.alertInformation}</Markdown.Preview>}
                            severity="info"
                            icon={faInfoCircle}
                        />
                    )
                }
                { 
                    !!formSectionConfiguration?.alertWarning && (
                        <BasicAlert
                            description={<Markdown.Preview>{formSectionConfiguration.alertWarning}</Markdown.Preview>}
                            severity="warning"
                            icon={faExclamationCircle}
                        />
                    )
                }
                { 
                    !!formSectionConfiguration?.alertError && (
                        <BasicAlert
                            description={<Markdown.Preview>{formSectionConfiguration.alertError}</Markdown.Preview>}
                            severity="error"
                            icon={faExclamationTriangle}
                        />
                    )
                }
                { 
                    !!formSectionConfiguration?.alertSuccess && (
                        <BasicAlert
                            description={<Markdown.Preview>{formSectionConfiguration.alertSuccess}</Markdown.Preview>}
                            severity="success"
                            icon={faCheckCircle}
                        />
                    )
                }
                {children}
            </Content>
            <Divider />
        </Paper>
    );
}

export default SourceDataFormGroupTitled;